import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { ApiService } from 'services';
import NoInternetPage from 'components/Errors/NoInternetPage';
import { updateConnectionStatus } from 'actions/common';

class ConnectionStatus extends Component {
  static propTypes = {
    // basicCheckUrl: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    onConnectionChanged: PropTypes.func,
    children: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node
    ]).isRequired,
    retries: PropTypes.number,
    showFullScreen: PropTypes.bool,
    connectionInfo: PropTypes.shape({
      rtt: PropTypes.number,
      downlink: PropTypes.number
    }),
    isOnline: PropTypes.bool,
    fullScreenOnly: PropTypes.bool
  };

  static defaultProps = {
    // basicCheckUrl: 'https://www.taina.tech/generate_204',
    onConnectionChanged: (event) => {},
    retries: 0,
    showFullScreen: false,
    connectionInfo: null,
    isOnline: true,
    fullScreenOnly: false
  };

  static CONNECTION_STATE_CHANGED = 'connection-state';

  static eventListenersLock = 0;

  static eventListenersSet = 0;

  static createConnectionStateEvent(isOnline) {
    const event = document.createEvent('CustomEvent');
    event.initCustomEvent(this.CONNECTION_STATE_CHANGED, true, true, { isOnline, state: isOnline ? 'Online' : 'Offline', date: new Date() });
    return event;
  }

  static handleOnlineOfflineEvent(event) {
    if (event && event.type && (event.type === 'online' || event.type === 'offline')) {
      const newState = event.type === 'online';
      window.dispatchEvent(ConnectionStatus.createConnectionStateEvent(newState));
    }
  }

  componentDidMount() {
    this.setEventListeners();
  }

  componentWillUnmount() {
    this.removeEventListeners();
  }

  handleConnectionStateChanged(event) {
    const { dispatch, onConnectionChanged, retries } = this.props;
    if (ApiService.globalRetryCount > 0 && event.detail.isOnline) {
      ApiService.globalRetryCount = 0;
      ApiService.processQueuedPromises(true);
    }

    dispatch(updateConnectionStatus(event.detail.isOnline, retries));
    if (onConnectionChanged) {
      onConnectionChanged(event);
    }
  }

  handleConnectionChanged(event) {
    const { isOnline } = this.props;
    const networkInfo = event.target;
    if (!isOnline && (networkInfo.rtt > 0 && networkInfo.downlink > 0)) {
      window.dispatchEvent(ConnectionStatus.createConnectionStateEvent(true));
    } else if (isOnline && (networkInfo.rtt === 0 || networkInfo.downlink === 0)) {
      window.dispatchEvent(ConnectionStatus.createConnectionStateEvent(false));
    }
  }

  /* eslint-disable no-dupe-class-members */
  handleConnectionChanged = this.handleConnectionChanged.bind(this);

  /* eslint-disable no-dupe-class-members */
  handleConnectionStateChanged = this.handleConnectionStateChanged.bind(this);

  setEventListeners() {
    const connection = null;
    const lockKey = Math.random() * (2 ** 32);
    // console.log(`Connection: ${ JSON.stringify(connection) }`);
    if (ConnectionStatus.eventListenersLock === 0) {
      ConnectionStatus.eventListenersLock = lockKey;
    }

    if (ConnectionStatus.eventListenersLock !== lockKey) {
      return;
    }

    if (ConnectionStatus.eventListenersSet === 0) {
      if (connection && connection.downlink >= 0 && connection.rtt >= 0) {
        connection.addEventListener('change', this.handleConnectionChanged);
      } else {
        window.addEventListener('online', ConnectionStatus.handleOnlineOfflineEvent);
        window.addEventListener('offline', ConnectionStatus.handleOnlineOfflineEvent);
      }

      window.addEventListener(ConnectionStatus.CONNECTION_STATE_CHANGED, this.handleConnectionStateChanged);
    }

    ConnectionStatus.eventListenersSet += 1;
    ConnectionStatus.eventListenersLock = 0;
  }

  getCssClass() {
    const { isOnline, showFullScreen } = this.props;
    if (isOnline) {
      return 'connected';
    }

    if (showFullScreen) {
      return 'full-screen';
    }

    return 'disconnected';
  }

  removeEventListeners() {
    if (ConnectionStatus.eventListenersSet === 1) {
      if (window.navigator) {
        const connection = null;
        if (connection) {
          connection.removeEventListener('change', this.handleConnectionChanged);
        }
      }
      window.removeEventListener('online', ConnectionStatus.handleOnlineOfflineEvent);
      window.removeEventListener('offline', ConnectionStatus.handleOnlineOfflineEvent);
      window.removeEventListener(ConnectionStatus.CONNECTION_STATE_CHANGED, this.handleConnectionStateChanged);
    }

    ConnectionStatus.eventListenersSet -= 1;
  }

  render() {
    const { children, showFullScreen, fullScreenOnly, isOnline } = this.props;

    return <React.Fragment>
      { !isOnline && showFullScreen && <div className="connection-status overlay" /> }
      { (!fullScreenOnly || !isOnline) && <div className={ `connection-status ${ this.getCssClass() }` }>
        { !isOnline && !showFullScreen && children != null && children }
        { !isOnline && showFullScreen && <NoInternetPage />}
        { isOnline && <span>Your connection has been restored.<br />Thank you for your patience.</span> }
      </div> }
    </React.Fragment>;
  }
}

function mapStateToProps(state) {
  const {
    common: {
      isOnline,
      connectionInfo,
    }
  } = state;

  return {
    isOnline,
    retries: ApiService.globalRetryCount,
    connectionInfo: connectionInfo || null,
    showFullScreen: ApiService.globalRetryCount > 1
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectionStatus);
